var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-panel-wrapper"},[_c('user-panel-header',{staticClass:"border-bottom"}),_vm._v(" "),_c('breadcrumbs',{attrs:{"hide-level":1}}),_vm._v(" "),_c('b-container',{staticClass:"user-panel-main",attrs:{"fluid":""}},[_c('router-view')],1),_vm._v(" "),_c('user-panel-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5ba9be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPanel/UserPanel.vue
// module id = null
// module chunks = 